import { render, staticRenderFns } from "./LabExpense.vue?vue&type=template&id=5accd209"
import script from "./LabExpense.vue?vue&type=script&lang=js"
export * from "./LabExpense.vue?vue&type=script&lang=js"
import style0 from "./LabExpense.vue?vue&type=style&index=0&id=5accd209&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports